import React,{ Component } from "react";
import { Link } from "react-router-dom";
import {connect} from "react-redux";
import { Row, Col, Table, Card, CardBody, CardHeader, Button} from "reactstrap";
import Proptypes from "prop-types";
import ReactJson from 'react-json-view';
import {getBrandingConfigs} from "../../../actions/actionBranding"
import iconNo from "../../../../assets/images/icon_no.svg";
import iconYes from "../../../../assets/images/icon_yes.svg";

class ViewBrandingConfig extends Component{
    constructor(props){
        super(props);
         this.state = {
            currentBrandingConfig: {}
        }
    }
  
    componentDidMount(){
        this.props.getBrandingConfigs();
    }
      
    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.branding_configs.length > 0){
            let currentBrandingConfig = nextProps.branding_configs.find(branding_configs => branding_configs.branding_config_id === this.props.match.params.id);
            this.setState({currentBrandingConfig: currentBrandingConfig});
        }
    }

    render(){
        const {currentBrandingConfig} = this.state;
        return (
            <div className="profile-page">
                <Row>
                    <Col sm={{ size: 8, order: 3, offset: 2 }}>
                        <Card >
                            <CardHeader>
                             <strong>View Branding Config</strong>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs="12">
                                        <div className="profile-table">
                                            {currentBrandingConfig ?
                                                <Table >
                                                    <tbody>
                                                        <tr><td><h4>Id</h4></td><td>{currentBrandingConfig.branding_config_id ? currentBrandingConfig.branding_config_id : "-"}</td></tr>
                                                        <tr><td><h4>Name</h4></td><td>{currentBrandingConfig.name ? currentBrandingConfig.name : "-"}</td></tr>
                                                        <tr><td><h4>Hostname</h4></td><td>{currentBrandingConfig.hostname ? currentBrandingConfig.hostname : "-"}</td></tr>
                                                        <tr><td><h4>Favicon Logo Url</h4></td><td>{currentBrandingConfig.favicon_logo_url ? currentBrandingConfig.favicon_logo_url : "-"}</td></tr>
                                                        <tr><td><h4>Header Logo URL</h4></td><td>{currentBrandingConfig.header_logo_url ? currentBrandingConfig.header_logo_url : "-"}</td></tr>
                                                        <tr><td><h4>Splash Background URL</h4></td><td>{currentBrandingConfig.splash_url ? currentBrandingConfig.splash_url : "-"}</td></tr>
                                                        <tr><td><h4>HTML Title</h4></td><td>{currentBrandingConfig.html_title ? currentBrandingConfig.html_title : "-"}</td></tr>
                                                        <tr><td><h4>Login Logo Url</h4></td><td>{currentBrandingConfig.login_logo_url}</td></tr>
                                                        <tr><td><h4>Login Splash Background URL</h4></td><td>{currentBrandingConfig.login_splash_url}</td></tr>
                                                        <tr><td><h4>Login Caption</h4></td><td>{currentBrandingConfig.login_caption ? currentBrandingConfig.login_caption : "-"}</td></tr>
                                                        <tr><td><h4>Loading Session Text</h4></td><td>{currentBrandingConfig.loading_session_text ? currentBrandingConfig.loading_session_text : "-"}</td></tr>
                                                        <tr><td><h4>Joining Session Text</h4></td><td>{currentBrandingConfig.joining_session_text ? currentBrandingConfig.joining_session_text : "-"}</td></tr>
                                                        <tr><td><h4>Deleting Session Text</h4></td><td>{currentBrandingConfig.destroying_session_text ? currentBrandingConfig.destroying_session_text : "-"}</td></tr>
                                                        <tr><td><h4>Default</h4></td><td><img src={currentBrandingConfig.is_default ? iconYes  : iconNo } alt="iconNo"/></td></tr>
                                                    </tbody>
                                                </Table> :" "}
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>   
                    </Col>
                </Row>
            </div>
        );}
}

ViewBrandingConfig.propTypes = {
    branding_configs: Proptypes.array,
    match: Proptypes.object,
};

export default connect(state => 
    ({
        branding_configs: state.branding.branding_configs || [],
    }),
dispatch => 
    ({  
        getBrandingConfigs: () => dispatch(getBrandingConfigs()),
    }))(ViewBrandingConfig);